<template>

<com-item name="collection.overview" :is-overview="(window.is.mobile) ? 2 : 3" :size="size" :loading="loading" :is-empty="!active">

	<template v-slot:stats>

		<com-overview 
			label="Level Efficiency" 
			type="percent" 
			:value="data.efficiency" 
			info="How efficiently your plays contribute to h-index growth." 
		/>

		<com-overview 
			label="Median Plays" 
			type="number" 
			:value="data.median" 
			info="Half of your h-index games have at least this many plays." 
		/>

		<com-overview 
			label="Play Concentration" 
			type="band" 
			:value="data.concentration" 
			:config="concentrationConfig"
			info="How focused your h-index plays are across games." 
		/>

		<com-overview 
			label="Play Share" 
			type="percent" 
			:value="data.plays" 
			info="How much of your total plays are focused on h-index games." 
		/>

		<com-overview 
			label="Collection Contribution" 
			type="percent" 
			:value="data.collection" 
			info="The percentage of h-index games that are in your collection." 
		/>

		<com-overview 
			label="Index Stability" 
			type="band" 
			:value="data.bias" 
			:config="biasConfig"
			info="How much change there is in the games each level of the ladder." 
		/>

		<com-overview 
			label="Past Favourites" 
			type="number" 
			:value="data.retired" 
			info="Games that once counted toward your h-index but no longer qualify."
		/>

		<com-overview 
			label="Near Misses" 
			type="number" 
			:value="data.near" 
			info="Games that are just one play away from joining your h-index."
		/>

		<com-overview 
			label="Cornerstones"
			type="number" 
			:value="data.overqualified" 
			info="Games with far more plays than the current h-index — your most replayed hits."
		/>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comOverview from './../common/Overview'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	data: function() {

		return {
			biasConfig: {
				bands: {
					590: 'Evergreen Pillars',
					440: 'Enduring Core',
					340: 'Reliable Returners',
					240: 'Mixed Tenure',
					150: 'Rotating Core',
					0: 'Flash Entries'
				},
				subtitles: {
					590: 'Deep commitment — some games anchor the index over most of its history',
					440: 'The h-index is carried by lasting staples',
					340: 'Many games stick around through several levels',
					240: 'A balanced blend of legacy games and newer additions',
					150: 'Mix of short-lived entries and some that stick',
					0: 'Games briefly qualify and then disappear — high churn'
				}
			},
			concentrationConfig: {
				bands: {
					90: 'Single Core',
					75: 'Clustered Favorites',
					60: 'Converging Core',
					40: 'Even Spread',
					20: 'Wide Spread',
					0: 'Flat Track'
				},
				subtitles: {
					90: 'Your plays are heavily focused on just one or two standout h-index games',
					75: 'A small group of games dominates your repeat plays',
					60: 'Several games get strong replay attention, but it’s not overly skewed',
					40: 'Your h-index plays are fairly even across your top games',
					20: 'Your h-index games are played quite evenly, with few clear favorites',
					0: 'You treat your h-index games almost identically — none really stand out yet'
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/overview']

		},

		active: function() {

			return this.data && !this.loading

		}

	}

}

</script>

<style scoped>

</style>